import { cva } from 'class-variance-authority';
import { textVariants } from '@/lib/_utils/basic-variants.ts';

export const iconVariants = {
	...textVariants,
	dark200: 'text-dark-200',
	dark300: 'text-dark-300',
	dark400: 'text-dark-400',
	dark950: 'text-dark-950',
	hot: 'text-[#FD5D18]',
	success700: 'text-success-700',
	orchid500: 'text-orchid-500',
	transparent: '',
};

export const variants = cva([], {
	variants: {
		variant: iconVariants,
		size: {
			xs: ['w-[10px]', 'h-[10px]'],
			sm: ['w-[15px]', 'h-[15px]'],
			md: ['w-[20px]', 'h-[20px]'],
			lg: ['w-[25px]', 'h-[25px]'],
			xl: ['w-[30px]', 'h-[30px]'],
			xxl: ['w-[32px]', 'h-[32px]'],
			xxxl: ['w-[40px]', 'h-[40px]'],
		},
	},
	compoundVariants: [],
	defaultVariants: {
		variant: 'white',
		size: 'md',
	},
});
